import React from "react";
import FancyButton from "@/components/ui/fancy-button";

export default function Custom404() {
  return (
    <div className="flex min-h-[calc(100vh-200px)] flex-col items-center justify-center px-4">
      <h1 className="text-4xl font-bold text-gray-900">Page Not Found</h1>
      <p className="mt-4 text-center text-lg text-gray-600">
        The feature you&apos;re looking for doesn&apos;t exist.
      </p>
      <FancyButton
        href="/"
        semiFancy
        className="mt-8 w-fit rounded-lg bg-blue-600 px-6 py-3 text-white hover:bg-blue-700"
      >
        Go back home
      </FancyButton>
    </div>
  );
}
